import type { ReactNode } from "react";

import { JobItem } from "@js/apps/jobs/components/job-item/index";
import type { JobListingJob } from "@js/types/jobs";

import { JobsContainer } from "./jobs-container";
import { JobsEmptyState } from "./jobs-empty-state";

import style from "./style.module.scss";

type JobsListingProps = {
  jobs: JobListingJob[];
  emptyState?: ReactNode;
  searchResults?: boolean;
};

export const JobsListing = ({
  jobs,
  emptyState,
  searchResults,
}: JobsListingProps) => {
  return (
    <div className={style.jobsListing}>
      {jobs.length ? (
        <JobsContainer>
          <div className={style.jobsListingList}>
            {jobs.map((job, index) => (
              <JobItem
                key={job.id}
                job={job}
                resultPosition={index}
                searchResults={searchResults}
              />
            ))}
          </div>
        </JobsContainer>
      ) : (
        emptyState || (
          <div className={style.jobsListingEmptyState}>
            <JobsEmptyState
              title="Sorry, there are no jobs available for that search"
              description="Try removing filters or changing some of your search criteria"
            />
          </div>
        )
      )}
    </div>
  );
};
